import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="animate-spin border-golden-yellow">
        <img 
          src="/ico/BottomLeft.png" 
          alt="Loading" 
          className="w-16 h-16"
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;